import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';

import removeHtml from '../../../util/remove_html_markup';
import { Section, SubSection } from '.';
import { SET_CLIENT_STATE, UPDATE_PAGE_DATA, PAGE_DATA, PAGE_LIST } from '../../../graphqls';

export default function ChildSection({
  childData: {
    enable,
    viewType,
    measureId,
    planNodeId,
    title,
    description,
    metricType,
    advancedMetric,
    advancedMetricType,
    singleTargetAggregationFunction,
  },
  parentPlanNodeId = 'home',
  isHomePage,
}) {
  const [childChecked, setChildChecked] = useState(enable);
  const [setState] = useMutation(SET_CLIENT_STATE);
  const [updatePageData] = useMutation(UPDATE_PAGE_DATA, {
    refetchQueries: [
      {
        query: PAGE_DATA,
        variables: {
          name: parentPlanNodeId,
        },
      },
      { query: PAGE_LIST },
    ],
  });

  const onToggle = () => {
    if (measureId) {
      updatePageData({
        variables: {
          name: measureId,
          cache: {
            enable: !childChecked,
            measureId,
          },
          itemId: measureId,
        },
      });
    } else {
      updatePageData({
        variables: {
          name: planNodeId,
          cache: {
            enable: !childChecked,
            planNodeId,
          },
          itemId: planNodeId,
        },
      });
    }

    setChildChecked(!childChecked);
  };
  const onClick = () => {
    if (measureId) {
      setState({
        variables: {
          selectedPlanNodeId: measureId,
          modalTypeShown: 'visualText',
        },
      });
    } else {
      setState({
        variables: {
          selectedPlanNodeId: planNodeId,
          modalTypeShown: 'featureText',
        },
      });
    }
  };
  const onSelect = ({ target: { value } }) => {
    updatePageData({
      variables: {
        name: measureId,
        cache: {
          viewType: value,
          measureId,
        },
        itemId: measureId,
      },
    });
  };
  const onEdit = () => {
    setState({
      variables: {
        selectedPlanNodeId: planNodeId,
        modalTypeShown: 'featureImage',
      },
    });
  };

  let content;

  if (isHomePage) {
    content = (
      <Section
        config={{
          label: removeHtml(title || description),
          toggle: {
            checked: childChecked,
            onChange: onToggle,
          },
        }}
      >
        <SubSection label="featureImage" customClass="child-card-thumbnail-image" onClick={onEdit} />
        <SubSection label="textInput" customClass="child-card-text-input" onClick={onClick} />
      </Section>
    );
  } else {
    content = (
      <Section
        config={{
          label: removeHtml(title || description),
          select:
            measureId &&
            (metricType === 'OriginalSingle' || (advancedMetric === 'Yes' && advancedMetricType === 'single_target')) &&
            singleTargetAggregationFunction !== 'none'
              ? {
                  value: viewType,
                  options: [
                    {
                      label: 'Daily',
                      value: 'daily',
                    },
                    {
                      label: 'Weekly',
                      value: 'weekly',
                    },
                    {
                      label: 'Monthly',
                      value: 'monthly',
                    },
                    {
                      label: 'Fiscal Quarter',
                      value: 'fiscalQuarter',
                    },
                    {
                      label: 'Fiscal Year',
                      value: 'fiscalYear',
                    },
                    {
                      label: 'Calendar Quarter',
                      value: 'calendarQuarter',
                    },
                    {
                      label: 'Calendar Year',
                      value: 'calendarYear',
                    },
                  ],
                  onChange: onSelect,
                  className: 'chart-group-by-options',
                }
              : undefined,
          toggle: {
            checked: childChecked,
            onChange: onToggle,
          },
        }}
      >
        <SubSection label={measureId ? 'visualText' : 'featureText'} customClass="child-card-text-input" onClick={onClick} />
      </Section>
    );
  }

  return <span className="child-card">{content}</span>;
}

ChildSection.propTypes = {
  childData: PropTypes.shape({
    enable: PropTypes.bool,
    viewType: PropTypes.string,
    measureId: PropTypes.string,
    planNodeId: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    metricType: PropTypes.string,
    advancedMetric: PropTypes.string,
    advancedMetricType: PropTypes.string,
    singleTargetAggregationFunction: PropTypes.string,
  }).isRequired,
  parentPlanNodeId: PropTypes.string,
  isHomePage: PropTypes.bool.isRequired,
};
